export const config = {
  clientId: "edae061e-cce7-4d67-9702-64405b00df0b",
  redirectUri: window.location.href,
  scopes: ["user.read", "offline_access"],
  response_type: "code"
};



// WEBPACK FOOTER //
// ./src/components/SocialLogin/ms-login/Config.js